// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Styles
import './styles.scss';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import { message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import Movie from 'components/commonComponents/Movie';
import { Fade } from 'react-reveal';
import Loader from 'components/commonComponents/Loader';
import EmptyState from 'components/commonComponents/EmptyState';

const Favourites = () => {
    const { currentLang } = useSelector((store) => store.commonData);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [favourites, setFavourites] = useState('');
    const [isLoadingFav, setIsLoadingFav] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchFavorites();
    }, [currentLang]);

    const fetchFavorites = async () => {
        setIsLoadingFav(true);
        const formData = new FormData();
        formData.append('language', currentLang?.id);
        const res = await fetchData(restAPIs.favourites(formData));
        setFavourites(res.movies);
        setIsLoadingFav(false);
    };

    const handleOnClickMovie = (item) => {
        navigate('/movie/' + item.movieId);
    };

    const removeFav = async (item) => {
        const formData = new FormData();
        formData.append('action', 'delete');
        formData.append('movieId', item.movieId);
        const res = await fetchData(restAPIs.favourites(formData));
        if (res.statusCode === 200) {
            setFavourites(res.movies);
            messageApi.open({
                type: 'success',
                content: 'Movie Removed',
            });
        }
        else {
            messageApi.open({
                type: 'error',
                content: res.errormessage,
            });
        }
    };

    return (
        <div className='container __innerTopPad' dir={currentLang?.id === 1 ? 'rtl' : 'ltr'}>
            <h3 className='__common-head'>{t('favourites')}</h3>
            {contextHolder}

            {isLoadingFav ? <Loader /> : (
                favourites && favourites.length > 0 ? (
                    <div className='__fav_grid_list'>
                        {favourites.map((item, idx) => (
                            <div className='__single_st' key={idx}>
                                <Movie
                                    image={item.picture}
                                    title={item.movieName}
                                    handleOnClick={() => handleOnClickMovie(item)} />
                                <button className='__del-bt' onClick={() => removeFav(item)}><DeleteOutlined /></button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <EmptyState message={t('sorry_no_res')} />
                )
            )}
        </div>
    );
};

export default Favourites;
